import { Modal } from 'antd';
import TabTPAuthorization from 'pages/ThirdParty/ThirdPartyDetail/Components/TabTPAuthorization';
import React from 'react';

export type TapTPAuthorizationModalProps = {
  visible: boolean;
  onCancel: () => void;
  tpid: number;
};

const TapTPAuthorizationModal = ({
  onCancel,
  visible,
  tpid,
}: TapTPAuthorizationModalProps) => {
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      width={1200}
      destroyOnClose
      footer={null}
    >
      <TabTPAuthorization tpid={tpid} />
    </Modal>
  );
};

export default TapTPAuthorizationModal;
